@import 'styles/mixins';
@import 'styles/variables';

.controls {
  display: flex;
  align-self: flex-start;
  margin: 0 10px 0 4px;
}

.controlButton {
  display: flex;
  height: 32px;
  padding: 0;
  aspect-ratio: 1;
  margin: 0 2px;
  transition: none;

  svg {
    fill: $grey-50;
  }

  &.stopButton svg {
    height: 12px;
    width: 12px;
  }

  &:hover {
    background: var(--neutral-5);
  }
}
